/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { EditorLabInfo } from '../../models/editor-lab-info';

export interface LabControllerFindEditorLabList$Params {
  language: string;
}

export function labControllerFindEditorLabList(http: HttpClient, rootUrl: string, params: LabControllerFindEditorLabList$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<EditorLabInfo>>> {
  const rb = new RequestBuilder(rootUrl, labControllerFindEditorLabList.PATH, 'get');
  if (params) {
    rb.path('language', params.language, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<EditorLabInfo>>;
    })
  );
}

labControllerFindEditorLabList.PATH = '/lab/editorList/{language}';
